import React, { useEffect, useRef, useState } from 'react'
import { IoMdMenu } from 'react-icons/io';
import Sidebar from '../sidebar/Sidebar';

const Header = ({ toggleOpen, setToggleOpen }) => {
  const [changePassModal, setChangePassModal] = useState(false)
  const menuRef = useRef(null);
  const buttonRef = useRef(null);
  const handleClickOutside = (event) => {
    if (
      menuRef.current &&
      !menuRef.current.contains(event.target) &&
      buttonRef.current &&
      !buttonRef.current.contains(event.target)
    ) {
      setChangePassModal(false);
    }
  };
  useEffect(() => {
    if (changePassModal) {
      document.addEventListener("click", handleClickOutside);
    } else {
      document.removeEventListener("click", handleClickOutside);
    }
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [changePassModal]);

  return (
    <>
      <div className="header-container">
        <div className="logo-container">
          <div className='menu-icon' onClick={() => setToggleOpen(!toggleOpen)}>
            <IoMdMenu style={{ color: "black", fontSize: "2rem" }} />
          </div>
          <h1>CALENDIFY</h1>
        </div>
      </div>

      {
        toggleOpen && <div className="side-bar-mobile">
          <Sidebar toggleOpen={toggleOpen} setToggleOpen={setToggleOpen} />
        </div>
      }
    </>
  )
}

export default Header